import React, { useEffect, useState } from "react";
import "./profile.css";
import { useNavigate, useLocation } from "react-router-dom";

const ProfileDetailsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const employeeCode = location.state?.employeeCode;

  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!employeeCode) {
      setError("No employee code provided");
      setTimeout(() => navigate("/"), 3000);
      return;
    }

    fetchProfileDetails();
  }, [employeeCode]);

  const fetchProfileDetails = async () => {
    try {
      const response = await fetch(
        `https://mondelezbc.vsmglobaltechnologies.com/api/user/details/${employeeCode}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch profile details");
      }

      const json = await response.json();

      if (!json.data) {
        throw new Error("No profile data found");
      }

      setProfileData(json.data);
      setLoading(false);
    } catch (err) {
      console.error("Profile fetch error:", err);
      setError("Failed to load profile details");
      setLoading(false);
      setTimeout(() => navigate("/"), 3000);
    }
  };

  const handleStart = () => {
    navigate("/report", { state: { employeeCode: employeeCode } });
  };

  if (loading) {
    return (
      <div className="prf-container">
        <div className="prf-card">
          <div className="prf-content">
            <p className="loading-text">Loading profile details...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="prf-container">
        
        <div className="prf-card">
          <div className="prf-content">
            <div className="error-display">
              <span className="error-icon">⚠️</span>
              <h2 className="error-title">Error</h2>
              <p className="error-message">{error}</p>
              <p className="redirect-note">
                Redirecting to home in 3 seconds...
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="prf-container">
      <a className="home-icon" href="/">
        <svg
          fill="#fff"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          width="35px"
          height="35px"
          viewBox="0 0 495.398 495.398"
        >
          <g>
            <g>
              <g>
                <path
                  d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
				v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
				c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
				c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"
                />
                <path
                  d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
				c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
				c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"
                />
              </g>
            </g>
          </g>
        </svg>
      </a>
      <div className="prf-card">
        {/* Header */}
        <div className="prf-header">
          <h1 className="prf-title">PROFILE</h1>
        </div>

        {/* Profile Content */}
        <div className="prf-content">
          <div className="prf-fields">
            <ProfileField label="Name" value={profileData.name} />
            <ProfileField label="Emp Id" value={profileData.employeeCode} />
            <ProfileField label="Designation" value={profileData.designation} />
            <ProfileField label="Category" value={profileData.category} />
            <ProfileField
              label="Deployment area"
              value={profileData.deploymentArea}
            />
            <ProfileField
              label="Responsibility"
              value={profileData.responsibility}
            />
            <ProfileField
              label="Reporting to"
              value={profileData.reportingTo}
            />
            <ProfileField
              label="Speak up reporting"
              value={profileData.speakUpReporting}
            />
            <ProfileField label="Mdlz SPOC" value={profileData.mdlzSpoc} />
          </div>

          {/* Update Button */}
          <div className="prf-button-container">
            <button className="prf-update-button" onClick={handleStart}>
              కొనసాగింది
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="prf-footer">
          <img
            src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 40'%3E%3Crect width='100' height='40' fill='%23e5e7eb'/%3E%3Ctext x='50' y='25' text-anchor='middle' fill='%236b7280' font-family='Arial' font-size='12'%3Esodexo%3C/text%3E%3C/svg%3E"
            alt="Sodexo"
            className="prf-sodexo-logo"
          />
        </div>
      </div>
    </div>
  );
};

// Profile Field Component
const ProfileField = ({ label, value }) => {
  return (
    <div className="prf-field">
      <span className="prf-field-label">{label}</span>
      <span className="prf-field-separator">:</span>
      <span className="prf-field-value">{value}</span>
    </div>
  );
};

export default ProfileDetailsPage;
